// ------------------------------------------------------------------------------
// name: useOnce - 仅生效执行一次的 hooks
// author: mudas
// created: 2024/12/30
// ------------------------------------------------------------------------------

import { useEffect, useRef } from 'react';

/**
 * 仅生效执行一次的 hooks
 * @param callback 返回 true 后进行标记，不再执行
 * @param deps
 */
export const useOnce = (callback: () => boolean | undefined, deps: any[]) => {
  const used = useRef<boolean | undefined>(false);

  useEffect(() => {
    if (!used.current && callback) {
      used.current = callback();
    }
  }, deps);
};
